export interface FoldOverride {
    status: string;
    expanded: boolean;
}

export type FoldOverrides = Readonly<Record<string, FoldOverride>>;

interface FoldableVa {
    id: string;
    status: string;
}

// Only the first open VA starts expanded, so the list opens calm with the next one to work in view.
export function defaultExpandedId<T extends FoldableVa>(
    round: readonly T[],
    isOpen: (va: T) => boolean
): string | null {
    return round.find(isOpen)?.id ?? null;
}

// A manual toggle holds until the VA's status changes; otherwise the default decides.
export function isRowExpanded(
    va: FoldableVa,
    overrides: FoldOverrides,
    defaultId: string | null
): boolean {
    const override = overrides[va.id];
    return override && override.status === va.status ? override.expanded : va.id === defaultId;
}
